import posthog from 'posthog-js';
import { config } from './config.js';

/**
 * Initializes the PostHog analytics library for tracking user interactions.
 */
export function initPostHog() {
  // Initialize PostHog
  posthog.init(config.postHogApiKey, {
    api_host: 'https://bees.katapultpro.com',
    defaults: '2026-01-30',
    opt_out_capturing_by_default: true
  });

  console.log('PostHog initialized');
}
